module.exports = function() {
  return new Worker(__webpack_public_path__ + "c2a0749158fd29bbbea5.worker.js");
};